// These are externally defined messages:
// https://github.com/robinpowered/covid19-screening-app/blob/master/pages/generic/respond/[responseId]/completed.tsx
export enum SurveyCompletionStatus {
  COMPLETE = 'survey completed', // When the survey has no pass/fail answers
  FAILED = 'survey failed',
  PASSED = 'survey passed',
}
